<!-- 提交成功页面 -->
<template>
  <div class="success">
    <div class="success__icon">
      <van-icon name="success" />
    </div>
    <template v-if="mode === 1">
      <div class="success__title">预约成功</div>
      <div class="success__desc">您已成功预约</div>
    </template>
    <template v-else-if="mode === 2">
      <div class="success__title">预约意向提交成功</div>
      <div class="success__desc">
        您已成功预约，我们将在24小时内与您联系，请保持手机畅通
      </div>
    </template>
    <template v-else>
      <div class="success__title">分诊提交成功</div>
      <div class="success__desc">
        请耐心等候，分诊信息提交成功后预计4个小时内会有专门人员与您取得联系，请保持手机畅通，感谢您的配合！
      </div>
    </template>
    <div class="success__btn">
      <el-button
        type="primary"
        @click="goHome"
      >返回首页</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "success",
  data() {
    return {
      mode: "",
    };
  },
  components: {},
  created() {
    this.mode = Number(this.$route.query.mode);
  },
  methods: {
    goHome() {
      this.$router.push("/appointment/home");
    },
  },
};
</script>
<style lang="scss" scoped>
.success {
  padding: 20px;
  text-align: center;
  .success__icon {
    margin-bottom: 20px;

    .van-icon {
      font-size: 60px;
      color: #67c23a;
      border: 1px solid #67c23a;
      border-radius: 50%;
      padding: 10px;
    }
  }
  .success__title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .success__desc {
    font-size: 14px;
    color: #999;
    margin-bottom: 20px;
  }
  .success__btn {
    a {
      display: inline-block;
      padding: 10px 20px;
      border-radius: 4px;
      background-color: #409eff;
      color: #fff;
    }
  }
}
</style>
